var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gamanza-tournament-notification',{attrs:{"skin":_vm.skin,"tournament":_vm.activeTournament,"debug":_vm.isTournamentDebug,"tournament-count":_vm.activeTournamentCount,"language":_vm.language},on:{"dismiss":_vm.dismissActiveTournament,"open":_vm.openTournaments}})
}
var staticRenderFns = []

export { render, staticRenderFns }